module.exports = __webpack_public_path__ + "static/media/visual-grammar-img-004.0a31b24a.jpg";